import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 md:py-16 px-4 bg-brand-gray border-t border-white/5" data-id="element-99">
      <div className="max-w-3xl mx-auto text-center" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="inline-flex items-center justify-center w-32 h-32 bg-brand-dark rounded-full border-4 border-brand-yellow mb-8 box-glow" data-id="element-101">
          <ShieldCheck className="w-16 h-16 text-brand-yellow" data-id="element-102" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-6xl text-white mb-6" data-id="element-103">
          PROBALO DURANTE <span className="text-brand-yellow" data-id="element-104">7 DÍAS.</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-gray-300 font-medium leading-relaxed" data-id="element-105">
          Si durante los próximos 7 días sentís que el contenido no cumple con
          lo prometido, podés solicitar la devolución correspondiente según las
          condiciones establecidas.
        </motion.p>
      </div>
    </section>;
}